<template>
  <b-container>
    <b-modal id="modal-1" @ok="update_custom_colours">
      <b-form-group label="Primary background" label-cols="4">
        <b-form-input type="color" v-model="site.colour.primary_background"></b-form-input>
      </b-form-group>

      <b-form-group label="Primary text" label-cols="4">
        <b-form-input type="color" v-model="site.colour.primary_text"></b-form-input>
      </b-form-group>

      <b-form-group label="Accent background" label-cols="4">
        <b-form-input type="color" v-model="site.colour.secondary_background"></b-form-input>
      </b-form-group>

      <b-form-group label="Accent text" label-cols="4">
        <b-form-input type="color" v-model="site.colour.secondary_text"></b-form-input>
      </b-form-group>
    </b-modal>

    <b-card-group deck>
      <b-card v-for="(colour, key) in constants.colours" :key="key" :class="{'palette': true, 'palette_selected': site.colour.key == key}" @click="update_colour(colour)">
        <div class='project-type-palette'>
          <i class="pal-item-1" :style="{'background-color': colour.primary_background}"></i>
          <i class="pal-item-2" :style="{'background-color': colour.secondary_text}"></i>
          <i class="pal-item-3" :style="{'background-color': colour.secondary_background}"></i>
        </div>
        <div class="colour-subtext">{{colour.description}}</div>
      </b-card>

      <b-card :class="{'palette': true, 'palette_selected': site.colour.key == 'custom'}" v-b-modal.modal-1 v-if="!hide_custom">
        <div class='project-type-palette'>
          <i class="pal-item-1" :style="{'background-color': site.colour.primary_background}"></i>
          <i class="pal-item-2" :style="{'background-color': site.colour.secondary_text}"></i>
          <i class="pal-item-3" :style="{'background-color': site.colour.secondary_background}"></i>
        </div>
        <div class="colour-subtext">Custom colours</div>
      </b-card>
    </b-card-group>
  </b-container>
</template>

<script>

import { db, serverTimestamp, FieldValue } from '@/main.js'

export default {
  name: 'colours',
  props: ['profile', 'site', 'hide_custom'],
  methods: {
    async update_custom_colours() {
      await db.collection('site').doc(this.site.id).update({
        colour: {key: 'custom', primary_background: this.site.colour.primary_background, secondary_background: this.site.colour.secondary_background, highlight: this.site.colour.highlight, primary_text: this.site.colour.primary_text, secondary_text: this.site.colour.secondary_text, svg_fill: this.site.colour.svg_fill}
      })
      await this.after_write()
    },
    async update_colour(colour) {
      await db.collection('site').doc(this.site.id).update({
        colour: colour
      })
      this.site.colour = colour
      await this.after_write()
    },
    async after_write() {
      await db.collection('deploy_queue').doc(this.site.id).set({updated: serverTimestamp(), update_count: FieldValue.increment(1)}, {merge: true})
    }
  },
}
</script>

<style scoped>
.style-header {
  font-weight: bold;
}

.palette_selected {
  background: #EFEFEF;
}

.palette:hover {
  background: #EFEFEF;
}

.palette {
  min-width: 14em;
  margin-bottom: 1em !important;
  text-align: center;
  cursor: pointer;
}

.project-type-palette {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 30px 20px 10px;
}

.colour-subtext {
  margin: 1em 1em;
}

.pal-item-1, .pal-item-2, .pal-item-3 {
  display: inline-block;
  width: 80px;
  height: 80px;
  background: #f5f5f5;
  border-radius: 50%;
}

.pal-item-1:not(:last-of-type), .pal-item-2:not(:last-of-type), .pal-item-3:not(:last-of-type) {
  margin-right: -35px;
}
</style>
